import { useContext } from "react";
import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { usePutFinanceAccount } from "@/features/accounts/finance/hooks/use-put-accounts";
import { useUpdateCrecaAccounts } from "@/features/accounts/creca/hooks/use-put-accounts";
import { useUpdatePaymentAccounts } from "@/features/accounts/payment/scraping/hooks/use-update-accounts";
import { usePutEcshopAccounts } from "@/features/accounts/ecshop/hooks/use-put-accounts";
import { useUpdateCsvExcelAccounts } from "@/features/accounts/csv-excel/hooks/use-put-accounts";
import { usePutOcrAccounts } from "@/features/accounts/ocr/hooks/use-put-accounts"
import { usePutScrapFinanceAccount } from "@/features/accounts/scrap-finance/hooks/use-put-accounts";

interface Props {
  onTapCompleteModal: (newName: string) => void;
}

export const useUpdateAccountName = ({onTapCompleteModal}: Props) => {
  const { updateFinanceAccounts } = usePutFinanceAccount();
  const { updateCrecaAccounts } = useUpdateCrecaAccounts();
  const { updatePaymentAccounts } = useUpdatePaymentAccounts();
  const { updateEcshopAccounts } = usePutEcshopAccounts();
  const { updateCsvExcelAccounts } = useUpdateCsvExcelAccounts();
  const { updateOcrAccounts } = usePutOcrAccounts();
  const { updateScrapFinanceAccounts } = usePutScrapFinanceAccount();
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  const updateAccountName = async (
    accountGroupId: string,
    mlinkAccountId: string,
    mlinkId: string,
    passbookType: string,
    newPassbookName: string
  ) => {
    // 口座名変更処理
    // 各API関数は errorHandledAsync でラップ済み、エラー時は undefined を返す
    let result: unknown;
    if (passbookType === "01") {
      // finance
      result = await updateFinanceAccounts(
        accountGroupId,
        mlinkAccountId,
        mlinkId,
        undefined, // selectedStatus
        undefined, // isAggregate
        newPassbookName,
      );
    } else if (passbookType === "09") {
      // scrap-bank
      result = await updateScrapFinanceAccounts(
        accountGroupId,
        mlinkAccountId,
        mlinkId,
        newPassbookName,
      );
    } else if (passbookType === "19659" || passbookType === "19660") {
      // creca
      result = await updateCrecaAccounts(
        accountGroupId,
        mlinkAccountId,
        undefined, // selectedStatus
        newPassbookName,
      );
    } else if (passbookType === "03" || passbookType === "10") {
      // payment
      result = await updatePaymentAccounts(
        accountGroupId,
        mlinkAccountId,
        mlinkId,
        newPassbookName,
      );
    } else if (passbookType === "20") {
      // ecshop
      result = await updateEcshopAccounts(
        accountGroupId,
        mlinkAccountId,
        mlinkId,
        undefined, // selectedStatus
        newPassbookName,
      );
    } else if (passbookType === "201" || passbookType === "202") {
      // csv-excel
      result = await updateCsvExcelAccounts(
        accountGroupId,
        mlinkAccountId,
        newPassbookName,
      );
    } else if (passbookType === "101") {
      // ocr
      result = await updateOcrAccounts(
        accountGroupId,
        mlinkAccountId,
        newPassbookName,
      );
    }

    // エラー時にresultはundefinedで返却．モーダルを閉じないようにするため，ここでreturnする．
    if (result === undefined) {
      return;
    }
    onTapCompleteModal(newPassbookName);
  };

  return {
    updateAccountName: errorHandledAsync(updateAccountName, setError),
  };
};
